import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultiCartFacade, OrderEntry } from '@spartacus/cart/base/root';
import { KnBrCartContextService } from 'src/app/store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { HttpClient } from '@angular/common/http';
import { OccEndpointsService, RoutingService } from '@spartacus/core';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { catchError, filter, Observable, Subject, of, switchMap, takeUntil, tap } from 'rxjs';
import { MediaComponent } from '@spartacus/storefront';
import { KnBrPhoneHelper } from 'src/app/shared/helpers/kn-br-phone-helpers';

interface CartItem {
  id: number;
  cartId: string;
  userId: string;
  salesArea: string;
  name: string;
  partNumber: string;
  brand: string;
  productCode: string;
  salesUnit: string;
  quantity: number;
  price?: number;
  compactThumb?: boolean;
  overageReason?: string;
  entryNumber?: string;
  product?: {
    maxOrderQuantity?: number;
  };
}

@Component({
  selector: 'knbr-request-quote-review',
  standalone: true,
  imports: [CommonModule, MediaComponent],
  templateUrl: './kn-br-request-quote-review.component.html',
  styleUrls: ['./kn-br-request-quote-review.component.scss'],
})
export class KnBrRequestQuoteReviewComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  cartEntries$: Observable<OrderEntry[]>;
  cartItems: CartItem[] = [];
  cartId: string = '';
  customerId: string = 'current';
  cartData:any;
  poNumber = '';
  poNumberError = '';
  checkoutDisabled = true;
  isLabels = false;
  cartContext$: Observable<string> = this.knBrCartContextService.get$;

  constructor(private multiCartFacade: MultiCartFacade,
    private knBrCartContextService: KnBrCartContextService,
    protected commonService: KnBrCommonService,
    private cdr: ChangeDetectorRef,
  private knBrPhoneHelper: KnBrPhoneHelper,) { }

  ngOnInit(): void {
    this.cartContext$
      .pipe(
        takeUntil(this.destroy$),
        tap((cartId) => {
          if (!cartId) {
            this.cartItems = [];
            this.commonService.showSpinner$.next(false);
          }
        }),
        filter((cartId) => !!cartId),
        tap(() => this.commonService.showSpinner$.next(true)),
        tap((cartId) => {
          this.cartId = cartId;
          this.multiCartFacade.reloadCart(cartId);
        }),
        switchMap((cartId) => this.multiCartFacade.getCart(cartId)),
        filter((cart) => !!cart),
        catchError((error) => {
          console.error('Error loading cart:', error);
          return of(null);
        })
      )
      .subscribe(
        (cart) => {
          if (!cart) return;

          this.cartData = cart;
          this.isLabels = String((cart as any).cartCategoryBrand || '').toLowerCase().includes('labels');

          if (cart && Array.isArray(cart.entries)) {
            this.cartItems = this.mapCartItems(cart);
          }

          this.commonService.showSpinner$.next(false);
          this.cdr.detectChanges();
        },
        (error) => {
          console.error('Error in review order:', error);
          this.commonService.showSpinner$.next(false);
        }
      );
  }

  private mapCartItems(cart: any): CartItem[] {
    return cart.entries.map((entry: any, index: number) => ({
      id: entry.entryNumber ?? index,
      cartId: cart.code ?? this.cartId,
      userId: cart.user?.uid ?? '',
      salesArea: entry?.salesArea ?? '',
      name: entry.product?.name ?? '',
      partNumber: entry.product?.code ?? '',
      brand: entry.product?.brandName ?? entry.product?.manufacturer ?? 'CARLISLE',
      productCode: entry.product?.code ?? '',
      salesUnit: entry.uom ?? 'EA',
      quantity: entry.quantity ?? 1,
      price: entry.product?.price?.value ?? 0,
      notes: entry?.entryNote ?? '',
      entryNumber: entry.entryNumber,
      product: {
        maxOrderQuantity: entry.product?.maxOrderQuantity ?? entry.product?.maxOrderQty,
        images: entry.product?.images ?? [],
      },
      knbrTotalPrice: entry.knbrTotalPrice ?? null,
      totalPrice: entry.totalPrice ?? null,
    }));
  }

  // ✓ Format phone number for display
  getFormattedPhone(): string {
    const phone = this.cartData?.deliveryAddress?.phone;
    if (!phone) return '-';
    return this.knBrPhoneHelper.formatPhoneNumber(phone);;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
